<div class="section-gap">
  <div class="shadowed action-taxanomy-wrapper">
    <div class="row">
      <div class="col-12">
        <kla-title [config]="titleConfig" [color]="color" [hideDots]="true"></kla-title>
      </div>
      <div class="col-12">
        <mat-accordion multi class="mb-2">
          <ng-container *ngFor="let panel of config.list">
            <kla-new-action-taxonomy-category *ngIf="panel.isVisible" [panel]="panel" [config]="config"></kla-new-action-taxonomy-category>
          </ng-container>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
